import DocumentCEDetailController from './document.ce.detail.controller';

export default {
    template: require('./document.ce.detail.html'),
    controller: DocumentCEDetailController
};
